/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { getAppRoutePrefix } from '../../../../helpers/common/helper';
import iconList from '../../assets/svg/LeftMenuIcons';

const baseURL = '/account';

// TODO: My Account's menu need to be store in content stack
const listItem = (brandIconColor, desktop) => {
    // /gifthistory-home-steaks // STY
    // /gifthistory-home-bakery // WLF
    // /gifthistory-home-cookies // CCO
    // /gifthistory-home-gift-baskets // H&D
    if (desktop) {
        return [
            {
                id: 1,
                label: 'Account Overview',
                url: `${baseURL}/account`,
                icon: iconList(brandIconColor).overview,
            },
            {
                id: 2,
                label: 'Profile & Password',
                url: `${baseURL}/profile`,
                icon: iconList(brandIconColor).profileAndPassword,
            },
            {
                id: 3,
                label: 'Celebrations Passport®',
                url: `${baseURL}/passport`,
                userRole: 'P',
                icon: iconList(brandIconColor).passport,
            },
            {
                id: 4,
                label: 'Contacts',
                url: `${baseURL}/address-book`,
                icon: iconList(brandIconColor).addressBook,
            },
            {
                id: 5,
                label: 'Order History',
                url: `${baseURL}/orders`,
                icon: iconList(brandIconColor).orders,
            },
            {
                id: 6,
                label: 'Subscriptions',
                url: `${baseURL}/subscriptions`,
                flag: 'is-account-subscription-enabled',
                icon: iconList(brandIconColor).subscriptions,
            },
            {
                id: 7,
                label: 'Gift List',
                url: `${baseURL}/gift-list`,
                regEx: /^\/gifthistory-home-(gift-baskets|steaks|bakery|cookies)\??/,
                flag: 'is-account-gift-list-enabled',
                icon: iconList(brandIconColor).giftList,
            },
            {
                id: 8,
                label: 'Payments',
                url: `${baseURL}/billing-address`,
                icon: iconList(brandIconColor).paymentAndBilling,
            },
            {
                id: 9,
                label: 'Communication Center',
                url: `${baseURL}/email-preference`,
                icon: iconList(brandIconColor).emailPreference,
            },
            {
                id: 10,
                label: 'Sign Out',
                url: getAppRoutePrefix() ? '/auth/api/logout' :'/auth/logout',
                icon: iconList(brandIconColor).signOut,
                type: getAppRoutePrefix() ?  'external-sign-out' : ''
            }
        ];
    }
    return [
        {
            id: 1,
            label: 'Change Password',
            url: `${baseURL}/change-password`,
            icon: iconList(brandIconColor).profileAndPassword,
        },
        {
            id: 2,
            label: 'Change Account Email',
            url: `${baseURL}/change-email`,
            icon: iconList(brandIconColor).changeEmail,
        },
        {
            id: 3,
            label: 'Celebrations Passport®',
            url: `${baseURL}/passport`,
            userRole: 'P',
            icon: iconList(brandIconColor).passport,
        },
        {
            id: 4,
            label: 'Contacts',
            url: `${baseURL}/address-book`,
            icon: iconList(brandIconColor).addressBook,
        },
        {
            id: 5,
            label: 'Order History',
            url: `${baseURL}/orders`,
            icon: iconList(brandIconColor).orders,
        },
        {
            id: 6,
            label: 'Subscriptions',
            url: `${baseURL}/subscriptions`,
            flag: 'is-account-subscription-enabled',
            icon: iconList(brandIconColor).subscriptions,
        },
        {
            id: 7,
            label: 'Gift List',
            url: `${baseURL}/gift-list`,
            regEx: /^\/gifthistory-home-(gift-baskets|steaks|bakery|cookies)\??/,
            flag: 'is-account-gift-list-enabled',
            icon: iconList(brandIconColor).giftList,
        },
        {
            id: 8,
            label: 'Payments',
            url: `${baseURL}/billing-address`,
            icon: iconList(brandIconColor).paymentAndBilling,
        },
        {
            id: 9,
            label: 'Communication Center',
            url: `${baseURL}/email-preference`,
            icon: iconList(brandIconColor).emailPreference,
        },
        {
            id: 10,
            label: 'Sign Out',
            url: getAppRoutePrefix() ?  '/auth/api/logout' : '/auth/logout',
            icon: iconList(brandIconColor).signOut,
            type: getAppRoutePrefix() ? 'external-sign-out' : ''
        }];
};

export default listItem;
